import React from "react";
import { Formik, Form, Field } from "formik";
import {
	Button,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	MenuItem,
	Radio,
	RadioGroup,
	TextField,
	FormGroup,
	Checkbox,
} from "@mui/material";
import styled from "styled-components";
import * as yup from "yup";
import { useMutation } from "react-query";
import axios from "axios";
import { ReactComponent as SuccessIcon } from "../src/assets/success.svg";
import { ReactComponent as ErrorIcon } from "../src/assets/error.svg";

export const StyledTextFieldContainer = styled(TextField)`
	width: 100%;
	display: flex;
`;

const StyledFormControl = styled(FormControl)`
	margin: 20px 0;
`;

const Container = styled(Form)`
	padding: 20px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	max-width: 800px;

	.MuiFormControl-root {
		margin: 10px 0;
	}
	.MuiTextField-root {
		margin: 20px 0;
	}
`;

const CenteredContainer = styled.div`
	display: flex;
	height: 100vh;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const ErrorText = styled.span`
	font-size: 12px;
	color: red;
`;

const createValidationSchema = () => {
	return yup.object({
		name: yup.string().required("Це поле є обов'язковим"),
		phone: yup.string().required("Це поле є обов'язковим"),
		from: yup.string().required("Це поле є обов'язковим"),
		servant: yup.string(),
		place: yup.string().required("Це поле є обов'язковим"),
		age: yup.number().required("Це поле є обов'язковим"),
	});
};

const days = ["22.12", "23.12", "24.12", "25.12"];

const RegisterForm = () => {
	const [error, setError] = React.useState("");
	const [success, setSuccess] = React.useState(false);
	const [price, setPrice] = React.useState(0);
	const [daysConfig, setDaysConfig] = React.useState({
		[days[0]]: {
			visit: true,
			food: { breakfast: false, lunch: false, dinner: false },
		},
		[days[1]]: {
			visit: true,
			food: { breakfast: false, lunch: false, dinner: false },
		},
		[days[2]]: {
			visit: true,
			food: { breakfast: false, lunch: false, dinner: false },
		},
		[days[3]]: {
			visit: true,
			food: { breakfast: false, lunch: false, dinner: false },
		},
	});

	React.useEffect(() => {
		let counter = 0;
		days.forEach((day) => {
			const food = daysConfig[day].food;
			if (food.breakfast) counter++;
			if (food.lunch) counter++;
			if (food.dinner) counter++;
		});
		setPrice(counter * 150);
	}, [daysConfig]);

	const sendToDo = (payload) =>
		api
			.post("", payload)
			.then((res) => res.data)
			.catch((err) => {
				return err;
			});

	const { mutate, isLoading } = useMutation(sendToDo, {
		retry: 5,
		onSuccess(data) {
			if (data?.response?.status === 404) {
				setError(data.message);
			} else {
				setSuccess(true);
			}
		},
		onError(error) {
			console.log("Failed", error);
			setError("fwfwef");
		},
	});

	const api = axios.create({
		baseURL: "https://forum2023-be.vercel.app/register",
	});

	const handleSubmit = (values) => {
		console.log("handleSubmit", values);

		const body = {
			name: values.name,
			phone: values.phone,
			from: values.from,
			servant: values.servant,
			place: values.place,
			age: values.age,
			days: daysConfig,
		};
		console.log("body", body);
		mutate(body);
	};

	if (error) {
		return (
			<CenteredContainer>
				<ErrorIcon />
				<div>
					{error
						? error
						: "Виникла помилка, перевірте всі введені дані"}
				</div>
				<Button variant="contained" onClick={() => setError("")}>
					Повернутись назад
				</Button>
			</CenteredContainer>
		);
	}

	if (success) {
		return (
			<CenteredContainer>
				<SuccessIcon />
				<div>Ви успішно пройшли реєстрацію</div>
			</CenteredContainer>
		);
	}

	const handleChangeDay = (e) => {
		const checkedv = daysConfig[e.target.name].visit;
		setDaysConfig((prev) => ({
			...prev,
			[e.target.name]: {
				visit: !checkedv,
				food: {
					breakfast: false,
					lunch: false,
					dinner: false,
				},
			},
		}));
	};

	const handleChangeFood = (e) => {
		const checkedv = e.target.name;
		const [day, month, _food, meal] = checkedv.split(".");
		const date = `${day}.${month}`;
		const current = daysConfig[date].food[meal];

		setDaysConfig((prev) => ({
			...prev,
			[date]: {
				...prev[date],
				food: {
					...prev[date].food,
					[meal]: !current,
				},
			},
		}));
	};

	return (
		<>
			<Formik
				initialValues={{
					name: "",
					phone: "",
					from: "",
					servant: "",
					place: "",
					age: "",
				}}
				onSubmit={handleSubmit}
				validationSchema={createValidationSchema}
			>
				{({ values, isValid, dirty }) => (
					<Container>
						<Grid container alignItems="center">
							<Grid
								item
								alignItems={"center"}
								justifyContent={"center"}
							>
								<h1
									style={{
										textAlign: "center",
									}}
								>
									Реєстрація
								</h1>
							</Grid>
							<Field name="name">
								{({ field, meta }) => {
									return (
										<StyledTextFieldContainer
											{...field}
											label="ПІБ"
											variant="outlined"
											error={meta.touched && !!meta.error}
											helperText={
												meta.touched && meta.error
											}
										/>
									);
								}}
							</Field>
							<Field name="phone">
								{({ field, meta }) => {
									return (
										<StyledTextFieldContainer
											{...field}
											label="Номер телефону"
											variant="outlined"
											error={meta.touched && !!meta.error}
											helperText={
												meta.touched && meta.error
											}
										/>
									);
								}}
							</Field>
							<Field name="age">
								{({ field, meta }) => {
									return (
										<StyledTextFieldContainer
											{...field}
											label="Вік"
											variant="outlined"
											error={meta.touched && !!meta.error}
											type="number"
											helperText={
												meta.touched && meta.error
											}
										/>
									);
								}}
							</Field>
							<Field name="from">
								{({ field, meta }) => {
									return (
										<StyledTextFieldContainer
											{...field}
											label="Місто"
											variant="outlined"
											error={meta.touched && !!meta.error}
											helperText={
												meta.touched && meta.error
											}
										/>
									);
								}}
							</Field>
							<Field name="servant">
								{({ field, meta }) => {
									return (
										<StyledTextFieldContainer
											{...field}
											label="Прізвище вашого служителя (необов'язково)"
											variant="outlined"
											error={meta.touched && !!meta.error}
											helperText={
												meta.touched && meta.error
											}
										/>
									);
								}}
							</Field>
							<Grid item xs={12} marginBottom={2}>
								<FormLabel id="demo-radio-buttons-group-label">
									Дні перебування на форумі
								</FormLabel>
								<FormGroup row>
									{days.map((day) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={
															daysConfig[day]
																.visit
														}
														onChange={
															handleChangeDay
														}
														name={day}
													/>
												}
												label={day}
											/>
										);
									})}
								</FormGroup>
							</Grid>
							<Grid item xs={12} marginBottom={2}>
								<FormLabel id="demo-radio-buttons-group-label">
									Харчування
								</FormLabel>
								{days.map((day, i) => {
									return (
										<FormGroup row>
											<FormLabel
												sx={{
													margin: "3px 15px 0 0",
													paddingTop: "7px",
												}}
												id="demo-radio-buttons-group-label"
											>
												{day}
											</FormLabel>
											<FormControlLabel
												control={
													<Checkbox
														disabled={
															i === 0 ||
															!daysConfig[day]
																.visit
														}
														checked={
															daysConfig[day].food
																.breakfast
														}
														onChange={
															handleChangeFood
														}
														name={`${day}.food.breakfast`}
													/>
												}
												label="Сніданок"
											/>
											<FormControlLabel
												control={
													<Checkbox
														disabled={
															i === 0 ||
															!daysConfig[day]
																.visit
														}
														checked={
															daysConfig[day].food
																.lunch
														}
														onChange={
															handleChangeFood
														}
														name={`${day}.food.lunch`}
													/>
												}
												label="Обід"
											/>
											<FormControlLabel
												control={
													<Checkbox
														disabled={
															!daysConfig[day]
																.visit
														}
														checked={
															daysConfig[day].food
																.dinner
														}
														onChange={
															handleChangeFood
														}
														name={`${day}.food.dinner`}
													/>
												}
												label="Вечеря"
											/>
										</FormGroup>
									);
								})}
								{values.age > 0 && values.age <= 5 && (
									<FormLabel id="demo-radio-buttons-group-label">
										Вартість харчування: безкоштовно
									</FormLabel>
								)}
								{values.age > 5 &&
									values.age <= 12 &&
									price > 0 && (
										<FormLabel id="demo-radio-buttons-group-label">
											Вартість харчування: {price / 2} грн
										</FormLabel>
									)}
								{values.age > 12 && price > 0 && (
									<FormLabel id="demo-radio-buttons-group-label">
										Вартість харчування:{" "}
										{price > 1200 ? 1200 : price} грн
									</FormLabel>
								)}
							</Grid>
							<Field name="place">
								{({ field, meta }) => (
									<StyledFormControl fullWidth>
										<FormLabel id="demo-radio-buttons-group-label">
											Місце проживання
										</FormLabel>
										<RadioGroup {...field} row>
											<FormControlLabel
												value="church"
												control={<Radio />}
												label="Молитовний будинок"
											/>
											<FormControlLabel
												value="other"
												control={<Radio />}
												label="Інше"
											/>
										</RadioGroup>
										{meta.touched && !!meta.error && (
											<ErrorText>
												{meta.touched && meta.error}
											</ErrorText>
										)}
										{field.value === "church" && (
											<FormLabel id="demo-radio-buttons-group-label">
												Обов'язково уточніть можливість
												проживання у вашого керівника
												молоді
											</FormLabel>
										)}
									</StyledFormControl>
								)}
							</Field>
							<Button
								variant="contained"
								fullWidth
								type="submit"
								disabled={isLoading}
							>
								Зареєструватись
							</Button>
						</Grid>
					</Container>
				)}
			</Formik>
		</>
	);
};

export default RegisterForm;
